<template>
  <div class="app-container">
    <div class="flex justify-between items-center mb-4">
      <el-form ref="queryForm"
               :model="queryParams"
               :inline="true"
               label-width="80px">
        <!-- <el-form-item label="姓名" prop="name">
          <el-input v-model="queryParams.name"
                    placeholder="请输入姓名"
                    clearable
                    size="small" />
        </el-form-item> -->
        <el-form-item label="报餐日期" prop="mealDate">
          <el-date-picker v-model="queryParams.mealDate"
                          type="date"
                          placeholder="选择日期"
                          value-format="yyyy-MM-dd"
                          size="small"
                          style="width: 100%" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     :loading="loading"
                     size="mini"
                     @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
          <!-- <el-button type="success"
                     icon="el-icon-download"
                     size="mini"
                     :disabled="list.length === 0"
                     @click="handleExport">导出</el-button> -->
        </el-form-item>
      </el-form>
    </div>

    <div class="gap"></div>

    <el-table v-loading="loading" :data="list">
      <el-table-column label="姓名" align="center">
        <template slot-scope="scope">
          {{ scope.row.userInfo ? scope.row.userInfo.name : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="性别" align="center">
        <template slot-scope="scope">
          {{ scope.row.userInfo ? scope.row.userInfo.gender : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="部门" align="center">
        <template slot-scope="scope">
          {{ scope.row.userInfo ? scope.row.userInfo.department : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="联系电话" align="center">
        <template slot-scope="scope">
          {{ scope.row.userInfo ? scope.row.userInfo.phone : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="报餐日期" align="center" prop="mealDate" />
      <el-table-column label="早餐" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.breakfast === '1' ? '✅' : '❌' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="午餐" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.lunch === '1' ? '✅' : '❌' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="晚餐" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.dinner === '1' ? '✅' : '❌' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="报餐时间" align="center" prop="createdAt" />
    </el-table>
    <div class="vips" v-if="userInfo.vips !== '1'">
      <span>完整功能仅对会员开放，非会员用户仅能查看10条报餐记录,请联系【管理员】升级会员</span>
    </div>
    <!-- <el-pagination
      v-show="total > 0"
      :total="total"
      :current-page="pageIndex"
      :page-size="pageSize"
      @current-change="getList"
      @prev-click="getList"
      @next-click="getList"
    /> -->
  </div>
</template>

<script>
import { getDateOrderDetail } from '@/api/menuOrders/index'

export default {
  name: 'MealOrderDetail',
  data () {
    return {
      pageIndex: 1,
      pageSize: 10,
      loading: false,
      list: [],
      total: 0,
      queryParams: {
        name: '',
        mealDate: ''
      },
      userInfo: null
    }
  },
  created () {
    let date = new Date();
    this.queryParams.mealDate = date.toISOString().split('T')[0];
    this.userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    this.handleQuery()
  },
  methods: {
    handleQuery () {
      this.pageIndex = 1
      this.getList()
    },
    getList (e) {
      if (e) {
        this.pageIndex = e
      }
      let data = {
        page: this.pageIndex,
        pageSize: this.pageSize,
        vips: this.userInfo.vips || '',
        companyCode: this.userInfo.companyCode || '',
        ...this.queryParams
      }
      if (!this.queryParams.mealDate) {
        return this.$message.error('请选择报餐日期')
      }
      this.loading = true
      getDateOrderDetail(data).then(res => {
        this.loading = false
        if (res.code == 200 || res.code == '200') {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error('获取数据失败')
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('网络错误')
      })
    },
    resetQuery () {
      this.queryParams = {
        name: '',
        mealDate: ''
      }
      this.handleQuery()
    },
    // 导出列表数据为CSV
    handleExport () {
      if (this.list.length === 0) {
        return this.$message.warning('暂无可导出的数据')
      }
      const headers = ['姓名', '性别', '部门', '联系电话', '报餐日期', '早餐', '午餐', '晚餐', '报餐时间']
      const rows = this.list.map(item => {
        const user = item.userInfo || {}
        return [
          user.name || '-',
          user.gender || '-',
          user.department || '-',
          user.phone || '-',
          item.mealDate || '-',
          item.breakfast === '1' ? '是' : '否',
          item.lunch === '1' ? '是' : '否',
          item.dinner === '1' ? '是' : '否',
          item.createdAt || '-'
        ]
      })
      // 拼接CSV字符串，加BOM头防止中文乱码
      let csv = '\uFEFF' + headers.join(',') + '\n'
      rows.forEach(row => {
        csv += row.map(cell => {
          // 含逗号的字段用双引号包裹
          if (String(cell).indexOf(',') > -1) {
            return '"' + cell + '"'
          }
          return cell
        }).join(',') + '\n'
      })
      // 创建Blob并下载
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `报餐明细_${this.queryParams.mealDate || '导出'}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(link.href)
    }
  }
}
</script>

<style scoped>
.gap {
  margin: 30px 10px;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.items-center {
  align-items: center;
}
.mb-4 {
  margin-bottom: 16px;
}
.vips{
  color: red;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/mealOrderDetail/index.vue